import { useState } from "react"
import { Ban, Check, ChevronDown, Search, ShieldCheck } from "lucide-react"

import { cn } from "@/lib/utils"
import { AI_CONSENT_COPY } from "./copy"

const LINE = "flex items-start gap-[10px] text-[13.5px] leading-[1.45] font-semibold text-foreground"
const LINE_ICON = "mt-px size-[18px] shrink-0 text-muted-foreground"

// What the customer allowed freelancers to do with AI (design AiConsent). Two
// of the three answers are one line; "all" is a list of seven uses, closed by
// default so it does not take over the column. A design order lists design
// uses, every other order writing uses.
export default function AiConsent({ consent }) {
  const [open, setOpen] = useState(false)

  if (consent.state !== "all") {
    const Icon = consent.state === "none" ? Ban : Search

    return (
      <div className={LINE}>
        <Icon className={LINE_ICON} strokeWidth={1.9} />
        <span>{AI_CONSENT_COPY[consent.state]}</span>
      </div>
    )
  }

  const uses = consent.design ? AI_CONSENT_COPY.design : AI_CONSENT_COPY.writing

  return (
    <div>
      <button type="button" aria-expanded={open} onClick={() => setOpen((current) => !current)} className={cn(LINE, "w-full text-left")}>
        <ShieldCheck className={LINE_ICON} strokeWidth={1.9} />
        <span className="flex-1">{AI_CONSENT_COPY.all}</span>
        <span className="rounded-full bg-secondary px-[7px] py-px text-[11px] font-bold text-muted-foreground">{uses.length}</span>
        <ChevronDown className={cn("mt-0.5 size-4 text-ink-3 transition-transform", open && "rotate-180")} strokeWidth={2} />
      </button>
      {open && (
        <ul className="mt-3 ml-7 flex flex-col gap-2">
          {uses.map((use) => (
            <li key={use} className="flex gap-2 text-[12.5px] leading-[1.45] text-muted-foreground">
              <Check className="mt-0.5 size-[14px] shrink-0" strokeWidth={2.4} />
              <span>{use}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
